import { LOCATION_CHANGE } from '../../../../../shared/frontend/libs/router/redux-store';
import { SET_STANDINGS_LEADERBOARD_DATA, SHOW_LOADING_SPINNER } from '../actions/mdiStandingsActionCreator';
import { TAction } from '../../../../../shared/frontend/scripts/actions/types/action';

export default function mdiStandingsReducer(state: Partial<any> = {}, action: TAction<any>): Partial<any> {
  switch (action.type) {
    case SET_STANDINGS_LEADERBOARD_DATA: {
      return {
        ...state,
        leaderboard: {
          ...action.payload
        }
      };
    }
    case SHOW_LOADING_SPINNER: {
      return {
        ...state,
        isLoading: action.payload
      };
    }
    case LOCATION_CHANGE: {
      if (action.payload.isFirstRendering) {
        return state; // server render may have pre-populated state, so we don't want to nuke it
      }
      return {};
    }
    default: {
      return state;
    }
  }
}
